module.exports = __webpack_public_path__ + "img/icon-pdf.5b2b67ad.svg";